import React, { useState, useEffect } from "react"
import Images from "../../commonComponents/Images/Images"
import Slider from "react-slick"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faChevronLeft, faChevronRight } from '@fortawesome/free-solid-svg-icons'
import DisplayModal from "../../commonComponents/DisplayModal/DisplayModal"
import { NavLink } from "react-bootstrap"
import axios from "axios"



const Certificates = () => {

    const [showPdf, setShowPdf] = useState(false);
    const [selectedPdf, setSelectedPdf] = useState(null);
    const [certificates, setCertificates] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const openPdfModal = (pdfSrc) => {
        setSelectedPdf(pdfSrc);
        setShowPdf(true);
    };

    // const certificatescarousel = [
    //     {
    //         id: 1,
    //         Image: Images.patentsCertificates,
    //         title: "GMP",
    //         pdfSrc: Images.certificate1,

    //     },
    //     {
    //         id: 2,
    //         Image: Images.patentsCertificates,
    //         title: "FSSAI",
    //         pdfSrc: Images.certificate2,

    //     },
    //     {
    //         id: 3,
    //         Image: Images.patentsCertificates,
    //         title: "MOH-UAE",
    //         pdfSrc: Images.certificate3,

    //     },
    //     {
    //         id: 4,
    //         Image: Images.patentsCertificates,
    //         title: "ECOCERT",
    //         pdfSrc: Images.certificate4,

    //     },
    //     {
    //         id: 5,
    //         Image: Images.patentsCertificates,
    //         title: "INDOCERT",
    //         pdfSrc: Images.certificate5,

    //     },
    //     {
    //         id: 6,
    //         Image: Images.patentsCertificates,
    //         title: "ADITICERT",
    //         pdfSrc: Images.certificate6,

    //     },
    //     {
    //         id: 7,
    //         Image: Images.patentsCertificates,
    //         title: "WHO-GMP Compliance",
    //         pdfSrc: Images.certificate7,

    //     },
    //     {
    //         id: 8,
    //         Image: Images.patentsCertificates,
    //         title: "ISO",
    //         pdfSrc: Images.certificate8,

    //     },
    // ]

    const settings = {
        dots: false,
        infinite: true,
        slidesToShow: 4,
        slidesToScroll: 1,
        autoplay: false,        // Enable autoplay
        autoplaySpeed: 1500,
        centerMode: false,
        responsive: [
            {
                breakpoint: 2560,
                settings: {
                    slidesToShow: 4,
                    prevArrow: <FontAwesomeIcon icon={faChevronLeft} />,
                    nextArrow: <FontAwesomeIcon icon={faChevronRight} />,
                }
            },
            {
                breakpoint: 1030,
                settings: {
                    slidesToShow: 4,
                    prevArrow: <FontAwesomeIcon icon={faChevronLeft} />,
                    nextArrow: <FontAwesomeIcon icon={faChevronRight} />,
                }
            },
            {
                breakpoint: 800,
                settings: {
                    slidesToShow: 2,
                    prevArrow: <FontAwesomeIcon icon={faChevronLeft} />,
                    nextArrow: <FontAwesomeIcon icon={faChevronRight} />,
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 1,
                    prevArrow: <FontAwesomeIcon icon={faChevronLeft} />,
                    nextArrow: <FontAwesomeIcon icon={faChevronRight} />,
                }
            },
        ],
    }

    // api integration of certificates 
    const apiUrl = process.env.REACT_APP_API_BASE_URL;
    const certificatesEndPoint = '/certificate_type/2'
    const certificateUrl = `${apiUrl}${certificatesEndPoint}`

    const fetchcertificates = () => {
        axios.get(certificateUrl).then((res) => {
            if (res.data.status === 0 || res.data.message === "No records found") {
                setCertificates([]);
            } else {
                setCertificates(res.data.data);
            }
            setLoading(false);
        })
            .catch((error) => {
                setError("Error fetching certificates data.");
                setLoading(false);
            })
    }
    useEffect(() => {
        fetchcertificates();
    }, [])

    return (
        <>
            {/* //certificates */}

            <div className="patentsCertificates header-bottom-line">
                <div className="pxy-75">
                    <h3 className="text-center py-20 ">certifications</h3>
                    <div className="mt-40">
                        <div className='card-carousel-main'>
                            {loading ? (
                                <p>Loading...</p>
                            ) : error ? (
                                <p>{error}</p>
                            ) : (
                                <Slider {...settings}>
                                    {certificates.map((obj) => (
                                        <NavLink onClick={() => openPdfModal(obj.pdf_path)}>
                                            <div className='carousel-card-main services-carousel' key={obj.id}>
                                                <div className='carousel-card-nav card'>
                                                    <h6 className="text-center mb-0">{obj.name}</h6>
                                                    <div className="img-container">
                                                        <img src={Images.patentsCertificates} className='carousel-card-img' width={"100%"} />
                                                    </div>
                                                </div>
                                            </div>
                                        </NavLink>
                                    ))
                                    }
                                </Slider>
                            )}
                        </div>
                    </div>
                </div>
            </div >
            <DisplayModal
                show={showPdf}
                onHide={() => setShowPdf(false)}
                pdfSrc={selectedPdf}
            />
        </>
    )
}
export default Certificates